// extracted by mini-css-extract-plugin
export var FooterContactCTA = "FooterContactCTA-module--FooterContactCTA--5f095";
export var socialNetworks = "FooterContactCTA-module--socialNetworks--d3a16";